// components/Columns/StockHistoryColumns.js
const stockColumns = () => [
  {
    Header: "Vehicle No",
    disableFilters: true,
    filterable: false,
    accessor: (row) => row?.Nozzel?.vehicle_no || "-",
  },
  {
    Header: "Previous Qty",
    accessor: "prevoius_qty",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "LTR",
    accessor: "ltr",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Current Qty",
    accessor: "current_qty",
    disableFilters: true,
    disableSortBy: false,
  },
  {
    Header: "Notes",
    accessor: "notes",
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Created By",
    disableFilters: true,
    filterable: false,
    accessor: (row) => row?.createdBy?.name || "-",
  },
  {
    Header: "Created At",
    disableFilters: true,
    filterable: true,
    accessor: (row) =>
      new Date(row.createdAt).toLocaleString("en-IN", {
        dateStyle: "short",
        timeStyle: "short",
      }),
  },
];

export default stockColumns;
